import React, { useEffect, useState } from 'react';
import { FadeIn } from './FadeIn';
import { Clock, Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
import { motion } from 'framer-motion';
export function Pricing() {
  const [selected, setSelected] = useState<'pro' | 'elite'>('elite');
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 47,
    seconds: 33
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          return {
            hours: 0,
            minutes: 0,
            seconds: 0
          };
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  const links = {
    pro: 'https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBPddgkVSw5kWEgAQ5MFOM/es-ar?_r=AQABNvEyhY79duVidBKvbVmtk3f0r_-hyWsy75SMpZZnxzk&cart_link_id=CGnhwqWr&preview_theme_id=151828791463',
    elite: 'https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBPdxVgHbVig9cN0izaXmk/es-ar?_r=AQAB28ywLZNyKfRUg1S9Z3xafHoe-sFeXzCYcxU_cNLeYJc&cart_link_id=sZWTrZ3E&preview_theme_id=151828791463'
  };
  const ctaText = {
    pro: '→ SÍ, QUIERO EL MEGAPACK NUTRI DEPORTIVA',
    elite: '→ SÍ, QUIERO EL MEGAPACK NUTRI DEPORTIVA + FORMULA PRO™'
  };
  return <section className="relative py-8 px-3 overflow-hidden" data-id="element-251">
      <div className="relative max-w-[680px] mx-auto" data-id="element-252">
        {/* Urgency Counter */}
        <FadeIn className="text-center mb-4" data-id="element-253">
          <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 rounded-full px-4 py-2 mb-3" data-id="element-254">
            <Clock size={18} className="text-red-400" data-id="element-255" />
            <span className="text-red-400 font-bold text-sm uppercase tracking-wide" data-id="element-256">
              Oferta termina en
            </span>
            <div className="flex items-center gap-1 font-mono" data-id="element-257">
              <span className="bg-red-500/20 text-red-300 font-bold text-lg px-2.5 py-1 rounded-lg" data-id="element-258">
                {pad(timeLeft.hours)}
              </span>
              <span className="text-red-400 font-bold" data-id="element-259">:</span>
              <span className="bg-red-500/20 text-red-300 font-bold text-lg px-2.5 py-1 rounded-lg" data-id="element-260">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-red-400 font-bold" data-id="element-261">:</span>
              <span className="bg-red-500/20 text-red-300 font-bold text-lg px-2.5 py-1 rounded-lg" data-id="element-262">
                {pad(timeLeft.seconds)}
              </span>
            </div>
          </div>
        </FadeIn>

        {/* Selectable Cards */}
        <div className="space-y-3 mb-5" data-id="element-263">
          {/* Card 1: Megapack Nutricionista 360º */}
          <FadeIn delay={0.1} data-id="element-264">
            <div onClick={() => setSelected('pro')} className={`relative bg-black rounded-xl p-4 md:p-6 flex items-center gap-3 md:gap-5 cursor-pointer transition-all group ${selected === 'pro' ? 'border-2 border-accent shadow-[0_0_30px_rgba(168,216,48,0.2)]' : 'border border-accent/25 hover:border-accent/50'}`} data-id="element-265">
              <div className={`shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'pro' ? 'border-accent' : 'border-white/20 group-hover:border-accent/50'}`} data-id="element-266">
                <div className={`w-3 h-3 rounded-full ${selected === 'pro' ? 'bg-accent' : 'bg-transparent'}`} data-id="element-267" />
              </div>

              <div className="flex-1 min-w-0" data-id="element-268">
                <h3 className={`text-lg md:text-xl font-bold mb-1 ${selected === 'pro' ? 'text-accent' : 'text-white'} font-[900] font-[Poppins,_sans-serif]`} data-id="element-269">
                  MEGAPACK NUTRI DEPORTIVA
                </h3>
                <p className="text-white/50 text-sm md:text-base" data-id="element-270">
                  Acceso al Megapack Nutri Deportiva + bonos
                </p>
              </div>

              <div className="text-right shrink-0" data-id="element-271">
                <p className="text-white/40 line-through text-sm mb-0.5" data-id="element-272">
                  $34.990
                </p>
                <p className={`text-2xl md:text-3xl font-bold ${selected === 'pro' ? 'text-accent' : 'text-white'}`} data-id="element-273">
                  $19.990
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Card 2: Elite */}
          <FadeIn delay={0.2} data-id="element-274">
            <div onClick={() => setSelected('elite')} className={`relative bg-black rounded-xl p-4 md:p-6 flex items-center gap-3 md:gap-5 cursor-pointer transition-all ${selected === 'elite' ? 'border-2 border-accent shadow-[0_0_30px_rgba(168,216,48,0.2)]' : 'border border-accent/25 hover:border-accent/50'}`} data-id="element-275">
              <div className="absolute -top-3 left-6 flex items-center gap-2" data-id="element-276">
                <span className="bg-accent text-black text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-277">
                  MÁS ELEGIDO
                </span>
                <span className="text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider bg-accent/80" data-id="element-278">
                  AHORRÁS $16.000
                </span>
              </div>

              <div className={`shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'elite' ? 'border-accent' : 'border-white/20'}`} data-id="element-279">
                <div className={`w-3 h-3 rounded-full ${selected === 'elite' ? 'bg-accent' : 'bg-transparent'}`} data-id="element-280" />
              </div>

              <div className="flex-1 min-w-0 pt-2" data-id="element-281">
                <h3 className={`text-lg md:text-xl font-bold mb-1 leading-tight ${selected === 'elite' ? 'text-accent' : 'text-white'} font-[900] font-['Open_Sans',_sans-serif] font-[700]`} data-id="element-282">
                  MEGAPACK NUTRI DEPORTIVA + FORMULA PRO™
                </h3>
                <p className="text-white/60 text-sm md:text-base" data-id="element-283">
                  Incluye el Megapack Nutri Deportiva + Formula Pro™
                </p>
              </div>

              <div className="text-right shrink-0 pt-2" data-id="element-284">
                <p className="text-white/40 line-through text-sm mb-0.5" data-id="element-285">
                  $43.990
                </p>
                <p className={`text-2xl md:text-3xl font-bold ${selected === 'elite' ? 'text-accent' : 'text-white'}`} data-id="element-286">
                  $27.990
                </p>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Main CTA */}
        <FadeIn delay={0.3} className="text-center mb-5" data-id="element-287">
          <motion.a href={links[selected]} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-accent hover:bg-accent/90 text-black font-bold md:text-xl py-5 px-8 rounded-xl shadow-lg shadow-accent/20 transition-all text-center text-[16px]" data-id="element-288">
            {ctaText[selected]}
          </motion.a>
          <p className="text-white/50 text-xs mt-3 italic" data-id="element-289">
            La opción más elegida por quienes quieren avanzar más rápido y
            cobrar mejor
          </p>
        </FadeIn>

        {/* Trust Bar */}
        <FadeIn delay={0.4} data-id="element-290">
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 bg-surface border border-accent/25 rounded-lg py-3 px-4" data-id="element-291">
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-292">
              <Lock size={16} className="text-accent" data-id="element-293" />
              Pago seguro
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-294">
              <Zap size={16} className="text-accent" data-id="element-295" />
              Acceso inmediato
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-296">
              <ShieldCheck size={16} className="text-accent" data-id="element-297" />
              Garantía 7 días
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-298">
              <CreditCard size={16} className="text-accent" data-id="element-299" />
              Mercado Pago
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}